import { SeatComponent } from "../../component/seat_component";
import { Define } from "../../data/const_define";
import { PokerComponent } from "../../component/poker_component";
import { IUserData } from "../../../../../public/model_data";
import ViewBase from "../../../../../../framework/core/mvvm/view_base";
import { DealCardsEffect } from "../../component/deal_cards_effect";
import AtlasHandleComp from "../../component/atlas_component";
import TexasAnimEffect from "../../component/texas_animation_effect";
import { TableHelp } from "../../help/table_help";
import Utility from "../../../../../../utility/utility";
import { TexasHoldSprite } from "../../component/texas_hold_sprite";
import GameUtil from "../../../../../../utility/game_util";

export class SeatViewBase extends ViewBase{
    //当前座位Node
    seatNode:cc.Node;

    //UI组件元素
    seatComponent:SeatComponent;
    //计时器id
    private intervalID:number = null;

    pokerPos:cc.Vec2[] = [];

    smallCardsAngle:number[] = [];

    Init(){
        this.seatComponent = this.seatNode.getComponent(SeatComponent);
        for (let eff of this.dealCardsEffect) {
            eff.init();
        }
        this.onInit();
    }

    get playerHands():PokerComponent[]{
        return this.seatComponent.mHands;
    }

    get betEndNode():cc.Node{
        return this.seatComponent.betEndNode;
    }

    get maxCardNode():cc.Node{
        return this.seatComponent.maxCardNode;
    }

    get smallCards():cc.Node[]{
        return this.seatComponent.smallCards;
    }

    get effectNode():cc.Node{
        return this.seatComponent.effectNode;
    }

    get isNoDestroy():boolean{
        if (this.seatNode != null && cc.isValid(this.seatNode, true)) {
            return true;
        }
        return false;
    }

    get clickNode():cc.Node{
        return this.seatComponent.active
    }

    setAllInNode(show:boolean){
        this.seatComponent.allInNode.active = show;
    }

    //重置手牌
    resumeHands(){
        for (let dc of this.dealCardsEffect) {
            dc.resumeHands();
        }
    }

    //-------------准备发牌
    beginDealCards(){
        for (let dc of this.dealCardsEffect) {
            dc.reset();
        }
    }

    //发牌
    dealCards(start:cc.Node,index:number){
        this.dealCardsEffect[index].dealCardsAction(start);
    }

    //弃牌
    throwCardsAction(source:cc.Node){
        for (let dc of this.dealCardsEffect) {
            dc.throwCardsAction(source);
        }
    }

    checkBetAction(goldNumb:number,func?:Function){
        this.goldRoot.stopAllActions();
        this.seatComponent.betMoveEffect.checkBet(goldNumb,func);
    }

    guiChi(target:cc.Node,func?:Function){
        this.seatComponent.betMoveEffect.guiChi(target,func);
    }

    //获得bet
    obtainBet(target:cc.Node,gold:number,comp:Function){
        this.seatComponent.betMoveEffect.obtainBet(target,this.betEndNode,gold,comp);
    }

    showBet(gold:number){
        this.goldRoot.stopAllActions();
        this.seatComponent.betMoveEffect.showBet(gold);
    }

    setDes(str:string){
        this.seatComponent.setDes(str);
    }

    setTestDes(str:string){
        this.seatComponent.setTest(str);
    }

    setServerActive(isShow:boolean){
        this.seatComponent.serverID.node.active = isShow;
    }

    setTestActive(isShow:boolean){
        this.seatComponent.testDes.node.active = isShow;
    }

    setGoldNumb(gold:number){
        let numb = TableHelp.addThousands(gold);
        this.seatComponent.userGold.string = numb;
    }

    setBetNumb(bet:number){
        let numb = TableHelp.addThousands(bet);
        this.seatComponent.goldNumb.string = numb;
    }

    setBet(isShow:boolean){
        this.goldRoot.active = isShow;
    }

    //设置操作描述
    setOperatorDes(value:string,opType:Define.OperatorType){
        let anim = this.seatComponent.operatorAnim;
        let nameNode = this.seatComponent.myName.node;
        let operatorNode = this.seatComponent.operatorNode;
        anim.active = (opType == 1);
        nameNode.active = (opType == 2);
        operatorNode.active = (opType == 0);
        if (opType == Define.OperatorType.Anim_Op) {
            anim.getComponent(TexasAnimEffect).playAllAnim();
        }else if (opType == Define.OperatorType.Image_Op) {
            let pattern = operatorNode.getComponent(TexasHoldSprite);
            pattern.setSprite(value);
            operatorNode.scale = 1;
            if (value == '7') {
                this.allInAction(operatorNode);
            }
        }else if (opType == Define.OperatorType.Name_Op) {
            let str = Utility.filterPlayerName(value);
            this.seatComponent.myName.string = str;
        }
    }

    allInAction(node:cc.Node){
        let big = cc.scaleTo(0.1,1.3);
        let small = cc.scaleTo(0.07,1);
        let seq = cc.sequence(big,small);
        node.stopAllActions();
        node.runAction(seq)
    }

    setPlayerInfo(data:IUserData){
        this.seatComponent.avatar.spriteFrame = data.avatarSprite;
    }

    setMask(isShow:boolean){
        this.seatComponent.mask.active = isShow;
    }

    get winner(){
        return this.seatComponent.winner;
    }

    get dealCardsEffect():DealCardsEffect[]{
        return this.seatComponent.twoSmallCards;
    }

    get animationNode():cc.Node{
        return this.seatComponent.animationNode;
    }

    //信息节点
    get inforNode():cc.Node{
        return this.seatComponent.active;
    }

    get goldRoot(){
        return this.seatComponent.goldRoot;
    }

    get colorSlider(){
        return this.seatComponent.countDown;
    }

    playGrades(isPlay:boolean,num?:number){
        let gradesNode = this.seatComponent.gradesNode;
        gradesNode.active = isPlay;
        if (isPlay) {
            let comp = gradesNode.getComponent(TexasAnimEffect);
            comp.playAnim(0)
            let lab = cc.find('node/numb',gradesNode).getComponent(cc.Label);
            let tempNumb = Math.abs(num);
            let gold = GameUtil.currencyFormatting(tempNumb);
            let str = num>0 ? '+' + gold:'-'+gold;
            lab.string = str;

        }
    }

    //赢家
    showWinAnim(maxCardsType:number,animEnd?:Function){
        this.animationNode.active = true;
        let nodes = this.seatComponent.animationNodes
        let anim = this.animationNode.getComponent(TexasAnimEffect);
        nodes[1].active = false;
        nodes[0].active = false;
        if (maxCardsType) {
            nodes[1].active = true;
            let atlas = this.animationNode.getComponent(AtlasHandleComp);
            atlas.fillSprites([Define.PokerDes[maxCardsType]])
            anim.playAnim(1);
            nodes[1].stopAllActions();
            TableHelp.delay(nodes[1],()=>{
                nodes[0].active = true;
                anim.playAnim(0);
                if (animEnd) {
                    animEnd();
                }
            },Define.vectorShowTime)

        }else{
            nodes[0].active = true;
            anim.playAnim(0);
            if (animEnd) {
                animEnd();
            }
        }
    }

    isShowWinAnim(isShow:boolean){
        this.animationNode.active = isShow;
        this.seatComponent.winAnim.active = false;
        let nodes = this.seatComponent.animationNodes
        for (let anim of nodes) {
            anim.active = false;
        }
    }

    showHands(isShow:boolean){
        this.seatComponent.showHands(isShow);
    }

    //显示牌型类型
    showMaxCardType(type:number){
        let atlas = this.maxCardNode.getComponent(AtlasHandleComp);
        atlas.fillSprites([ Define.PokerDes[type]])
    }
    //牌型类型的显示
    showMaxCardNode(isShow:boolean){
        this.maxCardNode.active = isShow;
    }

    //飘
    flyGameLab(isWin:boolean,numb:number){
        let str = GameUtil.currencyFormatting(numb)
        let node = this.seatComponent.winAnim;
        node.active = true;
        let anim = node.getComponent(TexasAnimEffect)
        let suzi = cc.find('anim_common_shuzi/shuzi',node);
        let pur = str.replace('.','a');
        TableHelp.setNodeString(suzi,'+' + pur)
        anim.playAllAnim();
    }

    hideOpTimeState(){
        this.colorSlider.hide();
    }

    setOpTime(time:number,isPlayer:boolean){
        this.colorSlider.setOpTime(time,Define.totalTime,isPlayer);
    }


    onInit() {
        this.seatComponent.showHands(false);
        this.animationNode.active = false;
        this.pokerPos.length = 0;
        //----end 位置 
        this.pokerPos.push(this.playerHands[0].node.position);
        this.pokerPos.push(this.playerHands[1].node.position);
        this.smallCardsAngle.push(8);
        this.smallCardsAngle.push(-8);

        this.setServerActive(false);
        this.setTestActive(false);
        this.setAllInNode(false);
        this.playGrades(false)
        this.colorSlider.hide();
    };

    //取消计时器
    cancleSlider(){
        this.colorSlider.hide();
    }

    recycleCheckBet(){
        this.seatComponent.betMoveEffect.recycleAllBet();
    }

    //游戏结束
    reset(){
        //停止计时器
        this.seatComponent.winAnim.active = false;
        this.cancleSlider();
        this.colorSlider.hide();
        this.winner.active = false;
        this.showHands(false);
        this.animationNode.active = false;
        this.seatComponent.operatorAnim.active = false;
        this.showMaxCardNode(false);
        this.setAllInNode(false);
        for (let hand of this.playerHands) {
            hand.stopPokerAction();
        }
        this.betEndNode.stopAllActions();
    };

    clear(){
        this.seatComponent.betMoveEffect.clear();
    }
}
